<template>
  <b-modal ref="orderHistoryModal" title="Order History" size="lg" hideFooter>
    <table class="table table-striped table-bordered" v-if="history.length > 0">
      <thead>
        <tr>
          <th>Comment</th>
          <th style="width: 25%;">Date</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="index" v-for="(item, index) of history">
          <td v-html="item.comment"></td>
          <td v-html="item.date_added"></td>
        </tr>
      </tbody>
    </table>
    <div v-else>No history recorded for this order yet.</div>
    <div class="row w-100 m-0" style="clear: both;">
      <div class="modal-footer d-block w-100">
        <button
          type="button"
          class="btn btn-secondary float-right"
          @click="hideModal"
        >
          Close
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["history"],
  name: "order-history-modal",
  data() {
    return {};
  },
  methods: {
    showModal() {
      this.$refs.orderHistoryModal.show();
    },
    hideModal() {
      this.$refs.orderHistoryModal.hide();
    }
  }
};
</script>
<style>
table.table-bordered tr td p {
  margin: 0;
}
</style>
